<template>
    <div>
      <search-box
        ref="searchBox"
        :columns="searchBoxColumns"
        @search="search"
        @btnReset="handleReset"
        :defaultValue="formData"
        :column="2"
      />
      <QS-common-table
        :data="tableData"
        :columns="tableColumns"
        row-key="id"
        :pagination="paginationData"
        @change="paginationChange"
      />
    </div>
  </template>

<script>
import config from './config'
// eslint-disable-next-line import/no-cycle
import { maintenanceOrderBindListApi,
  getRentPlanNamesApi,
  recreateOrderLinkAPi,
  getCarInfoApi,
  carLicenseManageLikeByVinApi,
  getCarSeriesListApi,
  getCarbrandListApi,
} from './services'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import {
  maintenanceLikeByNameApi,
  getCompanyProviderLikeByNameApi } from '../maintenanceProject/services'
import _cloneDeep from 'lodash/cloneDeep'
import { useQueryStringify } from '@/utils/useAutoQuery'

export default {
  name: 'leaseOrder',
  data() {
    const { searchBoxColumns, tableColumns } = config.call(this)
    return {
      tableData: [],
      searchBoxColumns,
      tableColumns,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      formData: {},
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    handleBrandIdChange(e) {
      if (e) {
        this.$refs.searchBox.formInline.carSeriesId = ''
        this.getCarSeriesList(e)
      }
    },
    // 司机ID，司机→客户列表，，搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openDriverListPage(params) {
      this.$router.push({
        path: '/driver/customerManage/detail',
        query: params,
      })
    },
    // 车辆ID、车牌号、VIN，车辆→车辆列表，用指定的筛选搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openCarListPage(params) {
      const query = {
        f: params,
      }
      this.$router.push(`/vehicle/vehicleManage/list?${useQueryStringify(query)}`)
    },
    // 车辆→维保管理→维保项目管理，搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openProjectPage(row) {
      this.$router.push({
        path: '/vehicle/maintenance/maintenanceProject',
        query: {
          id: row.itemId,
        },
      })
    },
    // 集团→采购→服务商管理→服务商列表，搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openservicePage(row) {
      this.$router.push({
        path: '/purchaseNew/serviceProvider/list',
        query: {
          serviceId: row.serviceId,
        },
      })
    },
    // 集团→采购→服务商管理→维保入驻审核，搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openCollaborationPage(row) {
      this.$router.push({
        path: '/purchaseNew/maintenanceReview/list',
        query: {
          id: row.collaborationId,
        },
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    openRentPlanPage(row) {
      // 指定租赁方案详情页
      this.$router.push({
        path: '/car_to_lease/leaseScheme/detail',
        query: {
          orderType: 1,
          id: row.rentPlanId,
        },
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    SearchOrder(row) {
      // 查看维保订单，车辆→维保管理→维保订单管理，租赁方案ID+合作关系ID+项目ID查询+用户ID+车辆ID查询
      this.$router.push({
        path: '/vehicle/maintenance/list',
        query: {
          rentPlanId: row.rentPlanId,
          collaborationId: row.collaborationId,
          itemId: row.itemId,
          carId: row.carId,
          driverId: row.driverId,
        },
      })
    },
    handleReset() {
      this.formData = {}
      this.tableData = []
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.maintenanceOrderBindList()
    },
    search(formData) {
      this.formData = formData
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.maintenanceOrderBindList()
    },
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.maintenanceOrderBindList()
    },
    // 车辆品牌
    // eslint-disable-next-line vue/no-unused-properties
    getCarbrandList() {
      this.carbrandList()
    },
    // 获取车系
    // eslint-disable-next-line vue/no-unused-properties
    getCarSeriesList(e) {
      this.carSeriesList(e)
    },
    // 获取vin
    // eslint-disable-next-line vue/no-unused-properties
    getCarLicenseManageLikeByVin(e) {
      this.carLicenseManageLikeByVin(e)
    },
    // 获取车牌号
    // eslint-disable-next-line vue/no-unused-properties
    getPlateNo(e) {
      this.getCarInfo(e)
    },
    // 获取项目名称
    getProjectNames(e) {
      this.getMaintenanceLikeByNameApi(e)
    },
    // getMaintenanceStoreName(e) {
    //   this.getMaintenanceStoreLikeByName(e)
    // },
    getCompanyProviderName(e) {
      this.getCompanyProviderLikeByName(e)
    },
    getRentPlanNames(e) {
      this.getRentPlanLikeByNames(e)
    },
    getDriversName(e) {
      this.getDriversLikeByName(e)
    },
    // eslint-disable-next-line vue/no-unused-properties
    recreateCreateOrder(row) {
      this.recreateOrderLink(row.id)
    },
    async recreateOrderLink(id) {
      const [err, _data] = await this.$to(recreateOrderLinkAPi({ id }))
      if (err) return
      const { code } = _data
      if (code === 1) {
        this.$message.success('创建成功')
      }
    },
    async maintenanceOrderBindList() {
      const [err, _data] = await this.$to(maintenanceOrderBindListApi({
        ...this.formData,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.paginationData.total = data.totalNum
          this.tableData = data.items
        }
      }
    },
    // 项目名称模糊查询
    async getMaintenanceLikeByNameApi(name) {
      const [err, _data] = await this.$to(maintenanceLikeByNameApi({ name }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'itemId') {
              const newData = data.map((ite) => {
                ite.name += `(${ite.id})`
                return ite
              })
              item.source = _cloneDeep(newData)
            }
            return item
          })
        }
      }
    },
    // 获取服务商名称
    async getCompanyProviderLikeByName(name) {
      const [err, _data] = await this.$to(
        getCompanyProviderLikeByNameApi({ name }),
      )
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'serviceId') {
              const newData = data.map((ite) => {
                ite.name += `(${ite.id})`
                return ite
              })
              item.source = _cloneDeep(newData)
            }
            return item
          })
        }
      }
    },
    // 租赁方案名称
    async getRentPlanLikeByNames(name) {
      const [err, _data] = await this.$to(getRentPlanNamesApi({ name }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'rentPlanId') {
              const newData = data.map((ite) => {
                ite.name += `(${ite.id})`
                return ite
              })
              item.source = _cloneDeep(newData)
            }
            return item
          })
        }
      }
    },
    async getDriversLikeByName(name) {
      if (!name || name.length < 1) return
      const [err, _data] = await this.$to(searchByCustomerNameSensitive({
        customerName: name,
        mixedType: 'YES',
      }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'driverId') {
              item.source = _cloneDeep(data)
            }
            return item
          })
        }
      }
    },
    async getCarInfo(name) {
      const [err, _data] = await this.$to(getCarInfoApi({ plateNo: name }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          if (!data || !data.carId) return
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'carIdForPlateNo') {
              item.source = [{ id: data.carId, name }]
            }
            return item
          })
        }
      }
    },
    async carLicenseManageLikeByVin(name) {
      const [err, _data] = await this.$to(carLicenseManageLikeByVinApi({ name }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          if (!data || !Array.isArray(data)) return
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'carIdForVin') {
              item.source = _cloneDeep(data)
            }
            return item
          })
        }
      }
    },
    async carSeriesList(name) {
      const [err, _data] = await this.$to(getCarSeriesListApi({ brandId: name }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          if (!data || !Array.isArray(data)) return
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'carSeriesId') {
              item.source = _cloneDeep(data)
              if (item.source.length > 0) {
                item.options.disabled = false
              }
            }
            return item
          })
        }
      }
    },
    async carbrandList(name) {
      const [err, _data] = await this.$to(getCarbrandListApi({ name }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          if (!data || !Array.isArray(data)) return
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'brandId') {
              item.source = _cloneDeep(data)
            }
            return item
          })
        }
      }
    },
  },
  created() {
    const { itemId, collaborationId } = this.$route.query
    this.formData.itemId = itemId
    this.formData.collaborationId = collaborationId
    this.maintenanceOrderBindList()
    this.getProjectNames()
    // this.getMaintenanceStoreName()
    this.getCompanyProviderName()
    this.getRentPlanNames()
    this.getDriversName()
    this.getCarbrandList()
  },
}
</script>

  <style lang="scss" scoped></style>
